<template lang="pug">
div
  section(class="separable")
    div(class="container")
      el-row
        el-col(:span="24", v-if="notificacaoWhatsApp")
          .containerBotaoWhatsapp
            div(:style="{'margin-right': isAmapa ? '2%' : '35%'}")
              p Notificação via whatsapp
              el-switch(
                v-if="processo"
                v-model="processo.notificarWhatsApp"
                active-color="#13ce66"
                @change="ativarDesativarNotificaWhatsApp(processo)"
              )
        el-col(:span="24")
          div.cardListagem(class="card")
            div(class="card-header") Listagem de mensagens
            div(class="card-body")
              .table-pointer
                el-row
                  el-table(
                    :data='conversa.content',
                    stripe,
                    :default-sort = "{ prop: 'id', order: 'descending' }",
                    @row-click="goTo",
                    style="cursor: pointer"
                  )
                    template(slot="empty") Não há mensagens.
                    el-table-column(
                      align="center"
                      prop="status",
                      width="90",
                    )
                      template(slot-scope='scope')
                        div(
                          v-if="checkVizualizacao(scope.row)"
                        )
                          span
                            i.fas.fa-envelope(style="font-size: 20px")
                        div(v-else)
                          span
                            i.fal.fa-envelope-open(style="font-size: 20px")
                    el-table-column(
                      prop='row',
                      label='Data e hora',
                      width='250',
                      :formatter="setData"
                    )
                    el-table-column(
                      prop='assunto',
                      label='Assunto',
                      min-width='430',
                    )

              slot

</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
const {notificacaoWhatsApp} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      processo: null,
      notificacaoWhatsApp
    }
  },

  async created () {
    this.processo = await this.getProcessoByProtocolo(this.$route.params.idCadastro)
  },

  methods: {
    ...mapActions({
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      ativarDesativarNotificaWhatsApp: 'processos/ativarDesativarNotificaWhatsApp'
    }),

    checkVazio (row, column, prop) {
      return prop || '-'
    },
    checkVizualizacao (row) {
      return row.ultimaMensagem && row.ultimaMensagem.status === 'ENVIADA'
    },

    goTo (data) {
      this.$router.push({
        name: 'conversa',
        params: {
          idConversa: data.id
        }
      })
    },

    setData (row) {
      if (row.ultimaMensagem?.dataEnviada) {
        const dataEnviada = row.ultimaMensagem?.dataEnviada
        return dataEnviada.includes('/') ? dataEnviada : moment(dataEnviada).format('DD/MM/YYYY')
      } else {
        return '-'
      }
    },

    setHora (row) {
      return row.ultimaMensagem?.horaEnviadaFormatada ? row.ultimaMensagem.horaEnviadaFormatada : '-'
    }
  },

  computed: {
    conversa: {
      get () {
        return this.$store.getters['conversas/conversasProcesso'].list
      }
    },
    isAmapa () {
      return process.env.ESTADO === 'ap'
    }
  }

}
</script>
<style lang="scss" scoped>

.table {
  tbody tr td {
    cursor: pointer;
  }
}

.titulo {
  color: #424242;
  font-size: 1.5rem;
}

.containerBotaoWhatsapp {
  display: flex;
  flex-direction: row-reverse;

  div {
    text-align: center;
  }
}

@media (max-width: 780px) {
  .cardListagem {
    position: relative;
    width: 300px;
  }

  .containerBotaoWhatsapp {
    position: relative;
    left: 50px;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .card .card-header {
    font-size: 26px;
    padding: 40px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppListaConversas.vue